import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { ToolTipContent, addLink } from '@atlaskit/editor-common/keymaps';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { canLinkBeCreatedInRange } from '@atlaskit/editor-common/utils';
import { LinkIcon, ToolbarButton, ToolbarTooltip } from '@atlaskit/editor-toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
export var LinkButton = function LinkButton(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useEditorToolbar = useEditorToolbar(),
    editorView = _useEditorToolbar.editorView;
  // Warning! Do not destructure editorView, it will become stale
  var _ref2 = editorView !== null && editorView !== void 0 ? editorView : {
      state: null,
      dispatch: null
    },
    state = _ref2.state;
  var canInsertLink = useSharedPluginStateWithSelector(api, ['hyperlink'], function (state) {
    var _state$hyperlinkState, _state$hyperlinkState2;
    return (_state$hyperlinkState = state === null || state === void 0 || (_state$hyperlinkState2 = state.hyperlinkState) === null || _state$hyperlinkState2 === void 0 ? void 0 : _state$hyperlinkState2.canInsertLink) !== null && _state$hyperlinkState !== void 0 ? _state$hyperlinkState : true;
  });
  var onClick = function onClick() {
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.hyperlink.commands.showLinkToolbar(INPUT_METHOD.FLOATING_TB));
  };
  var isEnabled;
  if (expValEquals('platform_editor_toolbar_aifc_fix_editor_view', 'isEnabled', true)) {
    isEnabled = canInsertLink;
  } else {
    isEnabled = state !== null && state !== void 0 && state.selection ? canLinkBeCreatedInRange(state === null || state === void 0 ? void 0 : state.selection.from, state === null || state === void 0 ? void 0 : state.selection.to)(state) : false;
  }
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: /*#__PURE__*/React.createElement(ToolTipContent, {
      description: formatMessage(messages.link),
      keymap: addLink
    })
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(LinkIcon, {
      label: formatMessage(messages.link),
      size: "small"
    }),
    onClick: onClick,
    testId: 'editor-toolbar__link-button',
    isDisabled: !isEnabled
  }));
};